import { useQuery } from '@apollo/client'
import { gql } from '@apollo/client'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { PageProps } from 'app/pages/typing'
import * as React from 'react'

const CUSTOMER_REPORT_QUERY = gql`
  query customer($id: ID!) {
    customer(id: $id) {
      metabaseReportUrl
    }
  }
`

const ReportIndex: React.FC<PageProps> = () => {
  const id = useCurrentCustomer().id

  const { data } = useQuery<{ customer: ICustomer }>(CUSTOMER_REPORT_QUERY, {
    variables: { id: id },
    pollInterval: 300 * 1000
  })

  const reportUrl = data?.customer?.metabaseReportUrl

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <iframe
        src={reportUrl}
        style={{ flex: 1, border: 'none' }}
        width="100%"
        title="klarxMANAGER - Reporting Dashboard"
        id="metabase"
      />
    </div>
  )
}

export default ReportIndex
